import { userAllowanceQueryAtomsFactory } from 'services/query-v2/allowance'
import { priceIndexV1Factory, priceAssetsFactory } from 'services/query-v2/prices'
import { PHTRPriceFactory } from 'services/query-v2/prices/phtr'
import { stakedPHTRPriceFactory } from 'services/query-v2/prices/staked-phtr'
import { indexV1OutputAmountAtomsFactory } from 'services/query-v2/zero-ex-requests/output'
import { EPHTRtoPHTROutputAmountAtomsFactory } from '../../../../../services/query-v2/zero-ex-requests/output/ephtr-to-phtr'
import { PHTRtoEPHTROutputAmountAtomsFactory } from '../../../../../services/query-v2/zero-ex-requests/output/phtr-to-ephtr'
import { userEscrowAtomsFactory } from 'services/query-v2/escrow-status'
import { rebalanceStatusAtomsFactory } from 'services/query-v2/rebalance-status'
import { priceIndexV2Factory } from 'services/query-v2/prices/index-v2'
import { indexV2OutputAmountAtomsFactory } from 'services/query-v2/zero-ex-requests/output/index-v2'
import { indexV2AnatomyAtomFactory } from 'services/query-v2/anatomy'
import { userContractStatusAtomsFactory } from 'services/query-v2/is-user-contract-status'
import { indexV1QuoteAtomsFactory } from 'services/query-v2/zero-ex-requests/quotes/quotes'

export const quotesQueryAtoms = indexV1QuoteAtomsFactory()

export const indexV1OutputQueryAtoms = indexV1OutputAmountAtomsFactory()
export const indexV2OutputQueryAtoms = indexV2OutputAmountAtomsFactory()

export const userAllowanceQueryAtoms = userAllowanceQueryAtomsFactory()

export const rebalanceStatusQueryAtoms = rebalanceStatusAtomsFactory()
export const userEscrowQueryAtoms = userEscrowAtomsFactory()
export const userContractQueryAtoms = userContractStatusAtomsFactory()

export const assetPriceQueryAtoms = priceAssetsFactory()
export const nativeAssetPriceQueryAtoms = priceAssetsFactory()
export const indexV1PriceQueryAtoms = priceIndexV1Factory()
export const indexV2PriceQueryAtoms = priceIndexV2Factory()

export const indexV2AnatomyQueryAtoms = indexV2AnatomyAtomFactory()

/**
 * PHTR staking factories
 */
export const PHTRToEPHTROutputQueryAtoms = PHTRtoEPHTROutputAmountAtomsFactory()
export const EPHTRtoPHTROutputQueryAtoms = EPHTRtoPHTROutputAmountAtomsFactory()

export const PHTRPriceQueryAtoms = PHTRPriceFactory()
export const StakedPHTRPriceQueryAtoms = stakedPHTRPriceFactory()
